import TadaIcon from '@apps-common/ui-icons/TaskingDashboard.jsx';
import {Box, Button, Tooltip, Typography} from '@mui/material';
import {object} from 'prop-types';
import React, {useState} from 'react';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {getExtentForGeometry} from '../util/map.js';

const truncateFloat = v => {
  return v.toFixed(3);
};

const formatCenter = center => {
  return truncateFloat(center[0]) + ', ' + truncateFloat(center[1]);
};

const formatConfidence = score => {
  return (score * 100).toFixed(1) + '%';
};

const TIPS = {
  COPY: 'Click to copy coordinates',
  COPIED: 'Copied!',
};

export const DetectInfo = ({detect}) => {
  const [tooltip, setTooltip] = useState(TIPS.COPY);

  if (!detect) {
    return false;
  }

  const hasClass = !!detect.properties.object_class_label;
  const hasScore = typeof detect.properties.score === 'number';

  const extent = getExtentForGeometry(detect.geometry);
  // lat/lon
  const center = [(extent[1] + extent[3]) / 2.0, (extent[0] + extent[2]) / 2.0];

  return (
    <React.Fragment>
      <Typography variant="h6" sx={{my: 2}}>
        Detection details
      </Typography>
      {hasClass && (
        <Box
          sx={{
            display: 'flex',
            marginBottom: 0.5,
          }}
        >
          <Box>Class:</Box>
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              justifyContent: 'right',
            }}
          >
            {detect.properties.object_class_label}
          </Box>
        </Box>
      )}
      {hasScore && (
        <Box
          sx={{
            display: 'flex',
            marginBottom: 0.5,
          }}
        >
          <Box>Confidence:</Box>
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              justifyContent: 'right',
            }}
          >
            {formatConfidence(detect.properties.score)}
          </Box>
        </Box>
      )}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: 0.5,
        }}
      >
        <Box>Location:</Box>
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'right',
          }}
        >
          <Tooltip placement="top" title={tooltip}>
            <Box
              sx={{
                display: 'inline',
              }}
            >
              <CopyToClipboard text={center.map(c => '' + c).join(',')}>
                <Box
                  onClick={() => {
                    setTooltip(TIPS.COPIED);
                  }}
                  onMouseLeave={() => {
                    setTooltip(TIPS.COPY);
                  }}
                  sx={{
                    display: 'inline',
                    '&:hover': {textDecoration: 'underline', cursor: 'pointer'},
                  }}
                >
                  {formatCenter(center)}
                </Box>
              </CopyToClipboard>
            </Box>
          </Tooltip>
        </Box>
      </Box>
      <Button
        color="primary"
        fullWidth
        variant="contained"
        startIcon={<TadaIcon />}
        href={`https://www.planet.com/tasking/orders/new/?geometry=POINT(${center[1]}%20${center[0]})`}
        target="_blank"
        rel="noopener"
        sx={{marginTop: 2}}
      >
        Task high-res image
      </Button>
    </React.Fragment>
  );
};

DetectInfo.propTypes = {
  detect: object,
};
